import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { SITE } from "../lib/site";

/**
 * Section-level CTA strip — reused after major sections.
 * Preserves navy/gold/paper palette and minimalist tone.
 */
export default function SectionCTA({
  title = "Fast Service. Friendly People. Done Right.",
  subtitle = "Professional auto tag, title, notary, and insurance services. All under one roof.",
  primaryLabel = `Call ${SITE.phone}`,
  primaryHref = SITE.phoneHref,
  secondaryLabel = "Get a Quote",
  secondaryTo = "/insurance",
  variant = "paper",
  testid = "section-cta",
}) {
  const isDark = variant === "dark";
  return (
    <section
      className={`border-t ${
        isDark
          ? "border-white/10 bg-[#0A192F] text-white"
          : "border-[#0A192F]/10 bg-[#FBF9F5] text-[#0A192F]"
      }`}
      data-testid={testid}
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-16 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="max-w-2xl">
          <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.05]">
            {title}
          </h3>
          {subtitle && (
            <p
              className={`mt-4 max-w-xl text-base leading-relaxed ${
                isDark ? "text-white/70" : "text-[#0A192F]/70"
              }`}
            >
              {subtitle}
            </p>
          )}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <a
            href={primaryHref}
            className="btn-gold justify-center"
            data-testid={`${testid}-primary`}
          >
            <Phone className="w-4 h-4" /> {primaryLabel}
          </a>
          <Link
            to={secondaryTo}
            className={`btn-ghost justify-center ${
              isDark ? "text-white border-white/50" : "text-[#0A192F]"
            }`}
            data-testid={`${testid}-secondary`}
          >
            {secondaryLabel} <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
